'use client';

import React, { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useRouter } from 'next/navigation';

// Import modular landing page components
import {
  LoadingSpinner,
  Navigation,
  HeroSection,
  HowItWorksSection,
  WhyWaitlistlySection,
  FeaturesSection,
  CTASection,
  Footer,
  MobileStickyCTA,
  LandingPageStyles,
  TestimonialsSection,
  FAQSection,
  ProductDemoAnimation,
  PromoBanner,
} from '@/components/marketing-ui';

export default function HomePage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (!loading && user) {
      router.push('/start');
    }
  }, [user, loading, router]);

  const [isVisible, setIsVisible] = useState(false);
  const [showStickyCTA, setShowStickyCTA] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    const handleScroll = () => {
      // Show sticky CTA after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA] text-gray-900 font-sans-landing selection:bg-violet-100 overflow-x-hidden pt-[100px]">
      <div className="fixed top-0 left-0 right-0 w-full z-[1001] flex flex-col">
        <PromoBanner />
        <Navigation isFixed={false} />
      </div>
      <HeroSection isVisible={isVisible} />

      {/* Product Demo Animation Section */}
      <section className="w-full flex justify-center py-16 bg-[#FAFAFA]">
        <div className="w-[90%] md:w-[70%] lg:w-[60%] flex flex-col items-center">
          <div className="text-center mb-12 max-w-3xl mx-auto">
            {/* <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-violet-100 text-violet-700 text-sm font-medium mb-4">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-violet-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-violet-500"></span>
              </span>
              Live Demo
            </div> */}
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
              Experience the Magic
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              No complex builders or coding required. Just answer a few questions and watch our AI build your perfect validation page in seconds.
            </p>
          </div>
          <ProductDemoAnimation />
        </div>
      </section>

      <HowItWorksSection />
      <WhyWaitlistlySection />
      <FeaturesSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
      <LandingPageStyles />
      <MobileStickyCTA isVisible={showStickyCTA} />
    </div>
  );
}
